const imagesGallery = renderItem => {
  return [
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606513/home-hakahonu/new-home/VIDEOS/LA_GRAN_JUNTA_lwjxxf.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/8ua-5JhYmqM?autoplay=0&rel=0&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>La Gran Junta</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606517/home-hakahonu/new-home/VIDEOS/RAI_u%CC%88CES_4_lrmx3i.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/c5TVEfwNPb4?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Raíces 4: Santiago de Chile</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606515/home-hakahonu/new-home/VIDEOS/RAI_u%CC%88CES_3_j4k00q.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/U2sb3H6CamI?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Raíces 3: Valles Sagrados</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606516/home-hakahonu/new-home/VIDEOS/RAI_u%CC%88CES_2_zymo9q.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/F1fJGinl2WU?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Raíces 2: Altiplano</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606513/home-hakahonu/new-home/VIDEOS/RAI_u%CC%88CES_1_ogq7ue.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/m9sVXB5gpts?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Raíces 1: Araucanía</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606512/home-hakahonu/new-home/VIDEOS/CONEXIO_u%CC%88N_-_COMPILADO_DIEGO_MEDINA_ocjfnw.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/cdbgCQMgy48?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Conexión: compilado de la leyenda surfer Diego Medina</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606513/home-hakahonu/new-home/VIDEOS/Haka_Honu_presenta-_Bajo_La_Gran_Montan_a%CC%82a_homenaje_a_Juan_Pablo_MohR_fnjg7u.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/U55DVUfQERU?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Bajo La Gran Montaña, homenaje a Juan Pablo Mohr</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606512/home-hakahonu/new-home/VIDEOS/Abriendo_Caminos-_Cajo_u%CC%88n_del_Maipo_xnatsu.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/axFAXn8IES8?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Abriendo Caminos: Cajón del Maipo</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606512/home-hakahonu/new-home/VIDEOS/Abriendo_Caminos-_Zapallar_rxdlig.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/3dotEjYBh4w?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Abriendo Caminos: Zapallar</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606512/home-hakahonu/new-home/VIDEOS/Abriendo_Caminos-_Las_Chilcas_kbnois.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/HSgvccGNJgk?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Abriendo Caminos: Las Chilcas</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606512/home-hakahonu/new-home/VIDEOS/Abriendo_Caminos-_El_Arraya_u%CC%88n_fthhfh.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/gr3CwUCiRbw?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Abriendo Caminos: El Arrayán</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606513/home-hakahonu/new-home/VIDEOS/Navegando_Dimensiones-_Homenaje_a_Leo_u%CC%88n_Vicun_a%CC%82a_tgqdem.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/sg0c_OgeHwI?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Navegando Dimensiones: Homenaje a León Vicuña</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606518/home-hakahonu/new-home/VIDEOS/Vai_Mana_4-_La_guerra_deshumaniza_n2ozbz.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/4HYXjG1FnMc?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Vai Mana 4: La guerra deshumaniza</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606519/home-hakahonu/new-home/VIDEOS/Vai_Mana_3-_La_Costa_Intervenida_ilqbsh.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/V4Xz3Gl4Y4A?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Vai Mana 3: La costa intervenida</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606519/home-hakahonu/new-home/VIDEOS/Vai_Mana_2-_Rapa_Nui_uahg3y.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/GEB8UCRlD_g?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Vai Mana 2: Rapa Nui</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606517/home-hakahonu/new-home/VIDEOS/Vai_Mana_1-_La_defensa_del_Lafken_h2fcnr.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/SB43yTzxfY4?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Vai Mana 1: La defensa de Lafkena</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606517/home-hakahonu/new-home/VIDEOS/SOULSTICIO_4_wfvz1q.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/09a5JeG3CSM?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Soulsticio 4</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606517/home-hakahonu/new-home/VIDEOS/Soulsticio_3-_Equinoccio_de_primavera._nok07d.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/23NS0oHO5MQ?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Soulsticio 3: equinoccio de primavera</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606516/home-hakahonu/new-home/VIDEOS/Soulsticio_2-_Invierno_kocq2e.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/6k2MqOAMM_8?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Soulsticio 2: Invierno</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606516/home-hakahonu/new-home/VIDEOS/Soulsticio_1-_Soul_surfing_al_ritmo_de_la_naturaleza_odvvzo.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/pB7dN89Cs1U?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Soulsticio 1: Soul surfing al ritmo de la naturaleza</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606514/home-hakahonu/new-home/VIDEOS/Haka_Honu_presenta-_Ohana_Nui_Familia_Grande_gvgrln.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/kp_UiQa2S00?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Ohana Nui, Familia Grande</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606514/home-hakahonu/new-home/VIDEOS/Haka_Honu_presenta-_Sharanam_Ganesha_Project_yqp3ow.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/E1eEVM52tVA?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Sharaman Ganesa Project</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606516/home-hakahonu/new-home/VIDEOS/Haka_Honu_presenta-_Supernova_oczqlw.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/MkR5YfKuLrE?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Supernova</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606513/home-hakahonu/new-home/VIDEOS/Cortometraje_Todos_Somos_Migrantes_g4wwp3.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/1KG8jTHtL-Q?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Todos Somos Migrantes</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606513/home-hakahonu/new-home/VIDEOS/Haka_Honu_presenta-_El_Cambio_de_la_Marea_expediciones_por_la_Patagonia_occidental._icfnrr.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/3ko_2Xrx3Sg?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>El Cambio de la Marea</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606512/home-hakahonu/new-home/VIDEOS/Caleta_Paci_u%CC%88fico-_la_senda_de_Diego_Medina_por_el_surf_chilen_kyd73w.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/VCvbo0Z4C2o?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Caleta Pacífico: la senda de Diego Medina por el surf chileno</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606519/home-hakahonu/new-home/VIDEOS/Taitao-_El_ruido_del_viento_y_el_mar._yk2s67.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/MBX3mS_dd-s?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Taitao: el ruido del viento y el mar</p>
        </div>
      ),
    },
    {
      thumbnail: `https://res.cloudinary.com/lippi-outdoor/image/upload/v1668606517/home-hakahonu/new-home/VIDEOS/Soulsticio-_Ba_u%CC%88rbara_Herna_u%CC%88ndez_la_Sirena_de_Hielo_daus8r.jpg`,
      embedUrl:
        'https://www.youtube.com/embed/f1EdRYqRm6Q?autoplay=1&showinfo=0&controls=0',
      renderItem,
      thumbnailLabel: (
        <div className='text'>
          <p>Soulsticio: Bárbara Hernández, la Sirena de Hielo</p>
        </div>
      ),
    },
  ]
}

export default imagesGallery
